import React, {useEffect} from 'react';
import {useDispatch} from 'react-redux';
import Modal from '../../../src/components/Common/Modal/Modal';
import EllipsesControl from '../Common/EllipsesControl/EllipsesControl';
import styled from 'styled-components';
import {labels} from '../../util/uiconstants';
import {NotificationType} from '../../util/enumerations';
import Utility from '../../util/utils';
import {triggerMaintenanceUsage} from '../../actions/engagementsaction';

/**
 * Displays a modal for blocker and informational system messages.
 * @param {object} notification - The notification object containing details to be displayed.
 * @param {boolean} show - A boolean indicating whether the modal should be shown.
 * @param {function} setShow - A function to update the show state of the modal.
 * @param {function} onOkClick - A callback function to be executed when the OK button is clicked.
 * @param {string|number} engagementId - The engagement ID for triggering maintenance usage API.
 * @returns {JSX.Element} The rendered BlockerInformationalModal component.
 */
const BlockerInformationalModal = ({
	notification,
	show,
	setShow,
	onOkClick,
	engagementId
}) => {
	const dispatch = useDispatch();

	useEffect(() => {
		if (
			show &&
			engagementId &&
			(notification?.otherId === NotificationType.Blocker ||
				notification?.otherId === NotificationType.Informational)
		) {
			dispatch(triggerMaintenanceUsage(engagementId)).catch(() => {});
		}
	}, [show, engagementId, notification?.otherId, dispatch]);

	return (
		<Modal
			modalsize="x-small"
			modalContainerClass="blocker-informational-modal"
			role="dialog"
			headerText={
				<EllipsesControl
					content={notification.otherName}
					tooltip={notification.otherName}
					noOfLines={1}
				/>
			}
			show={show}
			onOkClick={() => {
				if (notification.otherId === NotificationType.Informational)
					onOkClick?.();
				setShow(false);
			}}
			onClose={() => {
				setShow(false);
			}}
			labels={
				notification.otherId === NotificationType.Blocker
					? {
							modalConfirmBtnLabel: labels.close,
							modalCloseBtnTitletip: labels.close
					  }
					: {
							modalConfirmBtnLabel: labels.continue,
							modalCancelBtnLabel: labels.cancel,
							modalCloseBtnTitletip: labels.close,
							cancel: labels.cancel
					  }
			}
		>
			<StyledBlockerInformationalModalBody className="motif-body1-default-light">
				<p>{Utility.createRichTextElement(notification.otherText)}</p>
			</StyledBlockerInformationalModalBody>
		</Modal>
	);
};

export default BlockerInformationalModal;

const StyledBlockerInformationalModalBody = styled.section`
	p {
		margin-bottom: var(--px-16);
	}
`;
